import React, { useState } from 'react';
import axios from "axios";
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import './Captcha.css';

const Contact = () => {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });

  const [errors, setErrors] = useState({});

  // ✅ HARD CODED PRODUCTION URL (no conditions)
  const backendURL = "https://themps.global/api/send-mail";

  // Input change handler with phone number restriction
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Phone: only numbers, max 10 digits
    if (name === "phone") {
      const onlyNumbers = value.replace(/\D/g, '');
      if (onlyNumbers.length <= 10) {
        setFormData({ ...formData, [name]: onlyNumbers });
      }
      return;
    }

    // Name: only letters and spaces
    if (name === "name") {
      const onlyLetters = value.replace(/[^a-zA-Z\s]/g, '');
      setFormData({ ...formData, [name]: onlyLetters });
      return;
    }

    setFormData({ ...formData, [name]: value });
  };

  // Form validation
  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Full Name is required";
    }

    if (!formData.phone) {
      newErrors.phone = "Phone number is required";
    } else if (formData.phone.length !== 10) {
      newErrors.phone = "Phone number must be 10 digits";
    }

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    try {
      const response = await axios.post(backendURL, formData, {
        headers: { "Content-Type": "application/json" },
      });

      if (response?.data?.status === "success") {
        Swal.fire({
          icon: 'success',
          title: 'Sent!',
          text: 'Message sent successfully!',
          showConfirmButton: true,
          timer: 3000,
        });

        setFormData({ name: '', phone: '', email: '', message: '' });
        setErrors({});
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: response?.data?.message || 'Failed to send message. Please try again.',
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error?.response?.data?.message || 'Failed to send message. Please try again.',
        showConfirmButton: true,
      });
    }

    setLoading(false);
  };

  return (
    <div>
      <header className="site-header site-contact-header">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 col-12 mx-auto">
              <h1 className="text-white">Say Hi</h1>
              <strong className="text-white">
                We are happy to get in touch with you
              </strong>
            </div>
          </div>
        </div>
        <div className="video-wrap">
          <video autoPlay loop muted className="custom-video" poster="">
            <source src="video/contact_large.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="overlay"></div>
      </header>

      <section className="contact section-padding">
        <div className="container">
          <div className="row">

            <div className="col-12">
              <h2 className="mb-4">Leave a message</h2>
            </div>

            <div className="col-lg-6 col-12">
              <form className="custom-form contact-form row" onSubmit={handleFormSubmit}>

                <div className="col-lg-6 col-6">
                  <label className="form-label">
                    Full Name <a style={{ color: "red" }}>*</a>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Your Name"
                  />
                  {errors.name && <span className="text-danger">{errors.name}</span>}
                </div>

                <div className="col-lg-6 col-6">
                  <label className="form-label">
                    Phone Number <a style={{ color: "red" }}>*</a>
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Phone Number"
                    maxLength={10}
                  />
                  {errors.phone && <span className="text-danger">{errors.phone}</span>}
                </div>

                <div className="col-12">
                  <label className="form-label">
                    Email <a style={{ color: "red" }}>*</a>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Your Email"
                  />
                  {errors.email && <span className="text-danger">{errors.email}</span>}

                  <label className="form-label mt-3">
                    Message <a style={{ color: "red" }}>*</a>
                  </label>
                  <textarea
                    className="form-control"
                    rows="5"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="Your Message"
                  />
                  {errors.message && <span className="text-danger">{errors.message}</span>}
                </div>

                <div className="col-lg-5 col-12 ms-auto mt-3">
                  <button type="submit" className="form-control" disabled={loading}>
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        />
                        Submitting...
                      </>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>

              </form>
            </div>

            {/* Maps Section */}
            <div className="row mt-5">
              <div className="col-md-6">
                <h4 className="mt-5 mb-4">KPCT MALL, Fatima Nagar, Pune, Maharashtra</h4>

                <div className="google-map pt-3">
                  <iframe
                    title="KPCT Mall Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.5659619350517!2d73.89822067465174!3d18.503309469702394!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c1c5f0000001%3A0xcb943e93a77ea76c!2sKPCT%20mall!5e0!3m2!1sen!2sin!4v1715590043958!5m2!1sen!2sin"
                    width="100%"
                    height="300"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
              </div>

              <div className="col-md-6">
                <h4 className="mt-5 mb-4">Meydan Free Zone - Business Setup in Dubai, UAE</h4>
                <div className="google-map pt-5">
                  <iframe
                    title="Dubai Map"
                    src="https://www.google.com/maps/embed/v1/place?key=AIzaSyC81TuLbtUJhZBak4L0Kk_-0dlAEgZ0PA0&q=Meydan+Free+Zone+-+Business+Setup+In+Dubai,+UAE"
                    width="100%"
                    height="300"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
